import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBc = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#F58220",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 70 88",
	width: "1em",
	height: "1em",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M36.8 7.2c1.4 6.1-.3 13.5-3.3 14.2-3 .7-7.7-5.3-9.1-11.4-1.4-6.1.9-8.7 4.3-9.6 3.5-.7 6.6.7 8.1 6.8m-34.7 22c-.9 1.4-1.2 3-1.3 4.7-.2 6.9 6.8 13.7 16.4 16.7-.1-.1-18.8-10.1-15.1-21.4" }), /* @__PURE__ */ _jsx("path", { d: "M55.2 26.1c5-13.7-.3-16.9-7.6-6.9-5.5 7.6-13.9 11.1-32.3-1.1-4.8-3.2-8.4 1.1-3.9 5.7 8.5 8.7 10.2 18.9 12.1 28.2 12.5 1.7 22.8-3.5 23-11.8.1-3.5-1.7-7.1-4.8-10l-7-3.5s4.4.7 7.7-.7c-.1 1.5-.1 3 0 3.8 5.5 3.9 9.1 9.2 9 14.4-.2 9.2-11.3 15.1-25 13.7-.5-.1-1.1-.1-1.5-.2-8.3-1.1-15.8-4.8-20.5-9.5C8 54.8 20.2 58.9 24.8 60.3c.7 7.5.8 15.5 1.1 24.5.2 3.4 4.9 4.3 6.4 1.1 2.7-5.5 6.2-10.4 9.4-15.6 7.6-12.3 21.2-.1 26.7-4.1 6.1-4.7-22-15.8-13.2-40.1" })]
});
export default SvgBc;
